import PrimaryButton from './PrimaryButton.vue';

export default PrimaryButton;
